import { useState } from "react";
import { v4 as uuidv4 } from "uuid";

export const copyToClipboard = async (partkey, message) => {
  let toastItem = {};
  const itemId = uuidv4();

  await navigator.clipboard.writeText(partkey).then(
    function () {
      toastItem = {
        itemId: `${itemId}`,
        message: message,
        type: "success",
        autoHide: true,
      };
      return toastItem;
    },
    function () {
      /* clipboard write failed */
      return null;
    }
  );
  return toastItem;
};

export const getTableData = async (
  apiURL,
  path,
  apiKey,
  language,
  mident,
  lines,
  showAll = false
) => {
  async function fetchTable() {
    let varset = "";
    let lineid = null;
    let linesubid = null;

    let url = `${
      apiURL +
      "service/table?path=" +
      path +
      "&apikey=" +
      apiKey +
      "&language=" +
      language +
      "&mident=" +
      mident +
      "&showall=" +
      showAll +
      "&showma=" +
      showAll +
      "&varsettransfer=" +
      varset +
      "&selectrowlineid=" +
      lineid +
      "&selectrowlineidlow=" +
      linesubid
    }`;

    if (lines) {
      varset = lines[0]["varset"];
      lineid = lines[0]["lineid"];
      linesubid = lines[0]["linesubid"];

      url = `${
        apiURL +
        "service/table?path=" +
        path +
        "&apikey=" +
        apiKey +
        "&language=" +
        language +
        "&showall=" +
        showAll +
        "&showma=" +
        showAll +
        "&varsettransfer=" +
        varset +
        "&selectrowlineid=" +
        lineid +
        "&selectrowlineidlow=" +
        linesubid
      }`;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const json = await response.json();
      return json;
    } catch (error) {
      console.error(`Could not get table: ${error}`);
    }
  }

  const jsonPromise = fetchTable();
  return jsonPromise;
};

export const getTableDataOnChange = async (
  apiURL,
  path,
  apiKey,
  language,
  variable,
  value,
  varset,
  valueD,
  valueSD,
  showAll = false
) => {
  async function fetchTable() {
    try {
      const [tableResponse, dResponse, sdResponse] = await Promise.all([
        fetch(
          apiURL +
            "service/table?changeval=" +
            value +
            "&changevar=" +
            variable +
            "&path=" +
            path +
            "&varsettransfer=" +
            varset +
            "&apikey=" +
            apiKey +
            "&language=" +
            language +
            "&showall=" +
            showAll +
            "&showma=" +
            showAll
        ),
        fetch(
          apiURL +
            "service/table?changeval=" +
            valueD +
            "&changevar=" +
            "D" +
            "&path=" +
            path +
            "&apikey=" +
            apiKey +
            "&language=" +
            language
        ),
        fetch(
          apiURL +
            "service/table?changeval=" +
            valueSD +
            "&changevar=" +
            "SD" +
            "&path=" +
            path +
            "&apikey=" +
            apiKey +
            "&language=" +
            language
        ),
      ]);

      if (!tableResponse.ok) {
        throw new Error(`HTTP error: ${tableResponse.status}`);
      }
      if (!dResponse.ok) {
        throw new Error(`HTTP error: ${dResponse.status}`);
      }
      if (!sdResponse.ok) {
        throw new Error(`HTTP error: ${sdResponse.status}`);
      }

      // Wait for response
      const tableData = await tableResponse.json();
      const dataForValueSD = await dResponse.json();
      const dataForValueD = await sdResponse.json();

      return {
        tableData,
        dataForValueSD,
        dataForValueD,
      };
    } catch (error) {
      console.error(`Could not get table: ${error}`);
    }
  }

  const jsonPromise = fetchTable();
  return jsonPromise;
};

export const getMidentData = async (apiURL, part, apiKey, catalog) => {
  async function fetchMident() {
    try {
      const response = await fetch(
        apiURL +
          "service/reversemap?part=" +
          part +
          "&apikey=" +
          apiKey +
          "&catalog=" +
          catalog
      );
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const json = await response.json();
      return json;
    } catch (error) {
      console.error(`Could not get mident: ${error}`);
    }
  }

  const jsonPromise = fetchMident();
  return jsonPromise;
};

export const getSearchResult = async (apiURL, apiKey, query) => {
  async function fetchFulltextsearch() {
    try {
      const response = await fetch(
        apiURL +
          "service/fulltextsearch?query=" +
          query +
          "&apikey=" +
          apiKey +
          "&resulttype=lines" +
          "&num=9999"
      );
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const json = await response.json();
      return json;
    } catch (error) {
      console.error(`Could not get serach result: ${error}`);
    }
  }

  const jsonPromise = fetchFulltextsearch();
  return jsonPromise;
};

export const getImage = async (apiURL, format, apiKey, mident) => {
  async function fetchImage() {
    try {
      const response = await fetch(
        apiURL +
          "service/export?format=" +
          format +
          "&apikey=" +
          apiKey +
          "&mident=" +
          mident +
          "&version=;ColorSceme=blank"
      );
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const blob = await response.blob();

      function blobToBase64(blob) {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      }

      const image = await blobToBase64(blob);
      return image;
    } catch (error) {
      console.error(`Could not get image: ${error}`);
    }
  }

  const jsonPromise = fetchImage();
  return jsonPromise;
};

export const validateInfoKeys = (path, abbreviation) => {
  let validate = false;
  let keys = [];
  switch (path) {
    case "general": {
      return !validate;
    }

    case "series260":
      keys = ["KEY", "CT", "SD", "EL", "HUB", "POS", "V", "COL"];
      if (keys.includes(abbreviation)) {
        return !validate;
      }

    case "series380":
      keys = [
        "KEY",
        "El",
        "HUB",
        "POS",
        "MAT",
        "DAM",
        "SAE",
        "COL",
        "OPT",
        "RCOL",
        "DE",
        "TCOL",
      ];
      if (keys.includes(abbreviation)) {
        return !validate;
      }
      return validate;

    case "iso6022":
      keys = [
        "KEY",
        "MT",
        "CT",
        "SD",
        "EL",
        "HUB",
        "POS",
        "PRV",
        "DAM",
        "POSMS",
        "PS",
        "V",
        "COL",
        "CBA",
        "SAEPOS",
      ];
      if (keys.includes(abbreviation)) {
        return !validate;
      }
      return validate;

    default:
      return validate;
  }
};

// Template from https://usehooks.com/useLocalStorage
export const useLocalStorage = (key, initialValue) => {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.log(error);
    }
  };
  return [storedValue, setValue];
};

export const getLanguage = (language) => {
  switch (language) {
    case "de":
      return "german";
    case "en":
      return "";
    default:
      return "german";
  }
};

export const pushToDataLayer = (eventName, props) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "gaEvent",
    event_name: eventName,
    [eventName]: props,
  });

  // console.log(window.dataLayer);
};

export const checker = (arr) => arr.every((v) => v === true);
